import React, { useEffect } from "react";
import styled from "styled-components";
import SearchResultsHeader from "../Results/Header";
import SearchResultsList from "../Results/List";
import SearchResponseControls from "./Controls";
import SearchFeedbackLoading from "../Feedback/Loading";
import SearchFeedbackError from "../Feedback/Error";
import {
  handleEventSearchTerm,
  handleEventSearchProductClick,
} from "../../Common/Helpers/helpers";

import "./Response.scss";

const Response = styled.div`
  height: calc(100vh - ${(props) => props.marginTopDesktop || "100vh"});
  margin-top: ${(props) => props.marginTopDesktop || "80px"};

  @media screen and (max-width: 600px) {
    height: calc(100vh - ${(props) => props.marginTopMobile});
    margin-top: ${(props) => props.marginTopMobile};
  }
`;

const ResponseContainer = styled.div`
  max-width: ${(props) => props.responseWidth};
  margin: 0 auto;
`;

const ResponseBackground = styled.div`
  background: ${(props) => props.background};
  width: 100%;
`;

function SearchResponseComponent({
  data,
  isLoading,
  error,
  options,
  onClose,
  action,
}) {
  useEffect(() => {
    // Sending event search term to dataLayer
    if (data && !isLoading) {
      handleEventSearchTerm({
        action,
        term: data.term,
        resultsCount: data.count,
      });

      window.setTimeout(() => (window.location.hash = "done"), 200);
    }
  }, [isLoading, data]);

  const handleClickItem = (product) => {
    // Sending event click product to dataLayer
    handleEventSearchProductClick({
      term: data.term,
      productLabel: product.name || product.product_id,
    });
  };

  if (!isLoading && !data) return null;

  if (error) {
    return (
      <Response className="bn-search__response" {...options.customOptions}>
        <ResponseBackground
          className="bn-search__reponse-background"
          {...options.customOptions}
        >
          <ResponseContainer
            className="bn-search__response-container"
            {...options.customOptions}
          >
            <SearchFeedbackError message={error.message} options={options} />
          </ResponseContainer>
        </ResponseBackground>
      </Response>
    );
  }


  return (
    <Response className="bn-search__response" {...options.customOptions}>
      <ResponseBackground
        className="bn-search__reponse-background"
        {...options.customOptions}
      >
        <ResponseContainer
          className="bn-search__response-container"
          {...options.customOptions}
        >
          {isLoading && <SearchFeedbackLoading options={options} />}
          {data && !isLoading && (
            <>
              <SearchResponseControls options={options} onClose={onClose} />
              <SearchResultsHeader {...data} options={options} />
              <SearchResultsList
                {...data}
                options={options}
                handleClickItem={handleClickItem}
              />
            </>
          )}
        </ResponseContainer>
      </ResponseBackground>
    </Response>
  );
}

export default SearchResponseComponent;
